import React, { useState } from "react";
import Swal from "sweetalert2";

const Feedback = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  

  
  let saveFeedback = async () => {
    let response = await fetch(`${process.env.REACT_APP_URL}/feedback/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name: name, email: email, message: message }),
    });
    // let data = await response.json();
    if (response.status === 200) {
      Swal.fire({
        title: "Success",
        icon: "success",
        text: "Thank You!, for your feedback.",
      });
    } else {
      Swal.fire({
        title: "Error",
        icon: "error",
        text:
          "Thanks for your effort but due to some issue we did not save your feedback.",
      });
    }
  };


  return (
    <div className="container">
      <div id="loginform">
      <h2 id="headerTitle">Feedback</h2>
      <div class="rows">
      <label>Name:</label>
      <input
        type="text"
        placeholder="Enter the Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
    </div>
    <div class="rows">
      <label>Email:</label>
      <input
        type="text"
        placeholder="Enter the Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
    </div>
    <div class="rows">
      <label>Feedback:</label>
      <textarea
        type="text"
        placeholder="Put Your Feedback"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />
    </div>
    <div id="button" class="rows">
      <button onClick={saveFeedback}>Submit</button>
    </div>
      </div>
    </div>
  );
};

export default Feedback;
